// client/src/coms/components/comslayout_parts/serverApi.js
import { comsApiGet } from '../../comsApi';

export function pickDefaultChannel(server) {
  if (!server || !Array.isArray(server.channels) || !server.channels.length) return null;
  const firstText = server.channels.find((c) => c.kind === 'text');
  return firstText ? firstText.id : server.channels[0] ? server.channels[0].id : null;
}

export function makeChannelClientId(kind, dbId) {
  const k = String(kind || '').toLowerCase() === 'voice' ? 'voice' : 'text';
  const n = Number(dbId);
  return `${k}:${Number.isFinite(n) ? n : String(dbId)}`;
}

export function pickServerPublicId(s) {
  const obj = s && typeof s === 'object' ? s : {};
  const v =
    obj.public_id != null
      ? String(obj.public_id)
      : obj.server_key != null
        ? String(obj.server_key)
        : obj.serverKey != null
          ? String(obj.serverKey)
          : obj.id != null
            ? String(obj.id)
            : '';
  return String(v || '').trim();
}

export function pickServerDbId(s) {
  const obj = s && typeof s === 'object' ? s : {};
  const v =
    obj.db_id != null
      ? obj.db_id
      : obj.server_id != null
        ? obj.server_id
        : obj.serverId != null
          ? obj.serverId
          : obj.id != null
            ? obj.id
            : null;

  const n = Number(v);
  return Number.isFinite(n) ? Math.floor(n) : null;
}

export function pickServerIdFromJoinResponse(payload) {
  const p = payload && typeof payload === 'object' ? payload : {};
  const direct =
    p.server_key != null
      ? String(p.server_key)
      : p.public_id != null
        ? String(p.public_id)
        : p.server_id != null
          ? String(p.server_id)
          : p.serverId != null
            ? String(p.serverId)
            : p.id != null
              ? String(p.id)
              : p.server && p.server.public_id != null
                ? String(p.server.public_id)
                : p.server && p.server.server_key != null
                  ? String(p.server.server_key)
                  : p.server && p.server.id != null
                    ? String(p.server.id)
                    : p.server && p.server.server_id != null
                      ? String(p.server.server_id)
                      : '';

  const out = String(direct || '').trim();
  return out ? out : null;
}

export async function fetchServersFromApi() {
  const data = await comsApiGet('/my-servers');
  const list = Array.isArray(data?.servers) ? data.servers : [];
  const servers = [];

  for (const s of list) {
    const publicId = pickServerPublicId(s);
    const dbId = pickServerDbId(s);

    let channels = [];
    try {
      const ch = await comsApiGet(`/servers/${encodeURIComponent(String(publicId))}/channels`);
      const text = Array.isArray(ch?.text_channels) ? ch.text_channels : [];
      const voice = Array.isArray(ch?.voice_channels) ? ch.voice_channels : [];

      channels = [
        ...text.map((c) => ({
          id: makeChannelClientId('text', c.id),
          db_id: c.id,
          name: c.name,
          kind: 'text',
          topic: c.topic ? String(c.topic) : '',
        })),
        ...voice.map((c) => ({
          id: makeChannelClientId('voice', c.id),
          db_id: c.id,
          name: c.name,
          kind: 'voice',
        })),
      ];
    } catch {
      channels = [];
    }

    servers.push({
      id: String(publicId),
      db_id: dbId,
      name: s.name,
      owner_user_id: s.owner_user_id != null ? s.owner_user_id : s.ownerId != null ? s.ownerId : null,
      acronym: String(s.name || '').trim().slice(0, 4).toUpperCase() || 'SRV',
      channels,
      linkedMaps: [],
      members: [],
    });
  }

  return servers;
}